export default __webpack_public_path__ + "static/media/meta_input_icon.a4c5f5f8.svg";